// extracted by mini-css-extract-plugin
module.exports =  {"hidden":"VisuallyHidden-module__hidden___jNqmd"};